<template>
    <div class="center">
        <Login v-if="activeLoginView" @registerOnClick="registerOnClick" :registered="registered" />
        <Register v-else @registerOnClick="registerOnClick" :user="newUser" @cancelOnClick="activeLoginView = true"
            mode="register" />
        <router-view />
    </div>
</template>

<script>
import Login from '@/components/login module/Login.vue'
import Register from '@/components/login module/Register.vue'

export default {
    name: 'MainView',
    components: {
        Login,
        Register
    },
    data() {
        return {
            activeLoginView: true,
            registered: "",
            newUser: {
                firstName: "",
                lastName: "",
                username: "",
                password: "",
                company: "",
                email: "",
                phone: "",
            }
        }
    },
    methods: {
        registerOnClick(registered, activeLoginView) {
            this.registered = registered;
            this.activeLoginView = activeLoginView;
            this.newUser = {
                firstName: "",
                lastName: "",
                username: "",
                password: "",
                company: "",
                email: "",
                phone: "",
            };
        }
    }
}
</script>

<style scoped>
.center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>